/*
 * Copyright © 2018 Aram Meem Company Limited.  All Rights Reserved.
 */

import * as React from 'react';
import i18n from '../getText';
import { TimeItem } from '../models/time-item';
import { OrderStatus } from '../types';
import { DeliveryAddress } from "../models/delivery-address";
import { FormattedAddress } from "./FormattedAddress";
import { getETAmin } from "../helpers";

interface Params {
  timeline: TimeItem[],
  dropOffAddress: DeliveryAddress,
  pickUpAddress: DeliveryAddress
}

export class TimeLine extends React.Component<Params, any> {

  private vLineClasses = {};

  private dateFormatter = new Intl.DateTimeFormat('GB', {
    hour: 'numeric',
    minute: 'numeric'
  });

  private vLine = () => <div className="path_row-rout">
    <div className="path_row-dot"/>
    <div className="path_row-line"/>
  </div>;

  private itemClass = (index: number) => {
    return 'path_row ' + this.vLineClasses[index];
  }

  componentWillMount() {
    this.vLineClasses = this.convertTimelineToVLineClasses(this.props.timeline);
  }

  convertTimelineToVLineClasses(timeline: TimeItem[]): { [index: number]: string } {
    const classes = {};

    const stepCount = timeline.length;

    timeline.forEach((step, i) => {

      classes[i] = '';

      if (!step.future && (i + 1) < stepCount && !timeline[i + 1].future) {
        classes[i] = 'path_row--passed';
      }

      if (!step.future && (i + 1) < stepCount && timeline[i + 1].future) {
        classes[i] = 'path_row--current';
      }

      if (!step.future && stepCount === (i - 1)) {
        classes[i] = 'path_row--current';
      }

      if (!step.future && OrderStatus[step.type] === OrderStatus.COMPLETED) {
        classes[i] = 'path_row--passed';
      }

      if (OrderStatus[step.type] === OrderStatus.CANCELLED) {
        classes[i] = 'path_row--failed';
      }

    });

    return classes;
  }

  // for lang parsing
  private statusToName(timeItem: TimeItem): string {

    const orderStatus = timeItem.type.toString();

    switch (orderStatus) {

      case 'NEW':
        return i18n.pgettext('Timeline', 'Order placed');

      case 'NOT_CONFIRMED':
        return i18n.pgettext('Timeline', 'Not confirmed');

      case 'ON_THE_WAY_TO_PICK_UP':
        return i18n.pgettext('Timeline', 'Heading to pick-up location');

      case 'AT_PICK_UP':
        return timeItem.estimatedDate
          ? i18n.pgettext('Timeline', 'ETA to pick-up location')
          : i18n.pgettext('Timeline', 'Pick-up location');

      case 'ON_THE_WAY_TO_DROP_OFF':
        return i18n.pgettext('Timeline', 'Driving to drop-off location');

      case 'AT_DROP_OFF':
        return timeItem.estimatedDate
          ? i18n.pgettext('Timeline', 'ETA to drop-off location')
          : i18n.pgettext('Timeline', 'Drop-off location');

      case 'COMPLETED':
        return i18n.pgettext('Timeline', 'Delivered');

      case 'CANCELLED':
        return i18n.pgettext('Timeline', 'Order cancelled');

      default:
        return orderStatus;
    }

  }

  private timelineDate(timeItem: TimeItem) {

    if (timeItem.estimatedDate) {
      return <span>{i18n.pgettext('Timeline', 'in ### min').replace('###', getETAmin(timeItem.estimatedDate))}</span>;
    }
    if (timeItem.date) {
      return this.dateFormatter.format(timeItem.date * 1000);
    }
    return '';
  }


  render() {
    return (
      <div className="path-list">
        {this.props.timeline.map((timeItem: TimeItem, index: number) => {
          return <div className={this.itemClass(index)} key={index}>
            <div className="path_row-time">{this.timelineDate(timeItem)}</div>
            {this.vLine()}
            <div className="path_row-name">

              {this.statusToName(timeItem)}

              {OrderStatus[timeItem.type] === OrderStatus.AT_DROP_OFF
              && <div className="small-address"><FormattedAddress deliveryAddress={this.props.dropOffAddress}/></div>}

              {OrderStatus[timeItem.type] === OrderStatus.AT_PICK_UP
              && <div className="small-address"><FormattedAddress deliveryAddress={this.props.pickUpAddress}/></div>}

            </div>
          </div>
        })}

      </div>
    )
  }


}




// WEBPACK FOOTER //
// ./src/app/components/TimeLine.tsx